"use strict";

var getRangeLength = require("./getRangeLength");
var normalizePositionByRangeLength = require("./normalizePositionByRangeLength");

module.exports = function getMiddleOfRange(range, rangeMax) {
  var len = getRangeLength({ start: range.start, end: range.end }, rangeMax);
  return normalizePositionByRangeLength(range.start + Math.floor(len / 2), rangeMax);
};